import React from 'react';

import { Colors } from '../color/Colors';

export const HumanFactorLogo = ({style}: {style?: Record<string, any>}) => {
  return (
    <div>
      <img style={{ ...style, filter: Colors.logoFilter }} src='/pictures/HFLogo.svg' alt="Human Factor Logo" />
    </div>
  );
};